import { render, staticRenderFns } from "./ViajesView.vue?vue&type=template&id=785f1d24&scoped=true"
import script from "./ViajesView.vue?vue&type=script&lang=js"
export * from "./ViajesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f1d24",
  null
  
)

export default component.exports